<template>
    <div class="footer">
        <div @click="scrollTop2" class="pfixed tcenter">
            <span class="iconfont icon-huidingbu"></span>
            <div class="txt mt5">回顶部</div>
        </div>

        <div class="htmldiv">
            <div v-if="links" class="frienddiv tc-blue3 fs0 pt15 pb10 pl10 pr10">
                <a class="fs16 tiaozhuan" :href="$params.baseDir+'edu/teach-point/75'" title="点击跳转到高等学历继续教育（高起专）校外教学点">高等学历继续教育（高起专）校外教学点：杭州明珠专修学校、杭州市富阳区天骄教育培训学校、杭州市萧山区箭金培训学校、诸暨技师学院、绍兴市柯桥区依米培训学校、温州市里仁科技职业学校</a>
                <a v-for="item in links" :key="item.id" :href="item.link" target="_blank"
                    class="prelative before fs16 tc-blue3">
                    {{ item.title }}
                </a>

            </div>
            <div class="bdiv dflex jc-between ai-center twhite fs15">
                <a :href="$params.baseDir">
                    <img src="@/assets/images/jm_logo_b.png" alt="">
                </a>
                <div class="cpdiv pt10">
                    <div class="mb10 fs14">
                        <span class="mr15">地址：杭州下沙高教园东区学林街280号</span>
                        <span class="mr15">联系电话：0571-85024908，88064557</span>
                        <!--span>院办电话：0571-86929821</span-->
                    </div>
                    <div class="mb10 fs14">
                        <span class="mr15">继续教育投诉举报电话：0571-89718335</span>
                        <span class="mr15">招生投诉邮箱：jmjxjyxy@126.com</span>
                    </div>
                    <div class="mb10 fs14">
                        &copy;浙江经贸职业技术学院继续教育学院
                        <span class="ml20">ICP备案号：<a href="https://beian.miit.gov.cn/" target="_blank"
                                class="twhite">浙ICP备05013608号-3</a></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Bottom',
    data() {
        return {
            timer: null,
            frequency: 50,
            links: [],
            isLoad: false

        }
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                this.setRandom()
            }
        }
    },
    mounted() {
        let beginTime = 0; //开始时间
        let differTime = 0; //时间差
        window.onunload = function () {
            differTime = new Date().getTime() - beginTime;
            if (differTime <= 5) {
                localStorage.removeItem('random_id')
                console.log("这是关闭");
            }
            else { 
                console.log("这是刷新"); 
            }
        };
        window.onbeforeunload = function () {
            beginTime = new Date().getTime();
        };
        // window.onbeforeunload = this.beforeUnloadHandler
        // window.onunload = this.unloadHandler
        // window.onload = this.loadHandler
},
created(){
    this.setRandom()
},
methods: {
    scrollTop2() {
        let num = window.scrollY
        num = num - this.frequency
        if (num <= this.frequency) {
            num = 1
            window.scrollTo(0, num)
            clearTimeout(this.timer)
            this.timer = null
        } else {
            window.scrollTo(0, num)
            this.timer = setTimeout(this.scrollTop2, 10)
        }
    },
    setRandom(){ //生成随机数 生于记录站点浏览量
        var random_id = localStorage.getItem("random_id") || ''
        if (!random_id) {
            random_id = this.generateRandom()
            localStorage.setItem('random_id', random_id)
            this.$request.post('save-uv', { random_id }, res => {
                console.log(res)
            })
        }
    },
    generateRandom(){
        var n = new Date().getTime()
        var add = parseInt(Math.random() * 1000); //随机生成三位数
        add = add == 1000 ? 999 : add
        return n + add.toString()
    }
}
}
</script>
<style scoped>
.tiaozhuan{
    cursor: pointer;
    color:white;
}
.pfixed {
    z-index: 999;
    right: 20px;
    bottom: 30%;
    cursor: pointer;
    animation: up infinite 2s ease-in-out;
    ;

}

.pfixed:hover {
    animation-play-state: paused;
}

.pfixed {
    font-size: 15px;
    color: var(--blue2);
}

.pfixed .iconfont {
    font-size: 40px;
    color: var(--blue2);
}</style>